import { FETCH_PREVIEW_BLOCK_RECEIVED } from '../../types/reducers/preview';

export function previewBlockFetched(payload) {
  return {
    type: FETCH_PREVIEW_BLOCK_RECEIVED,
    payload
  };
}
